<div
  #slide
  id="slide"
  [class]="[
    'full',
    isVideo(sources[$active()]) ? 'video-background' : 'image-background',
  ]"
>
  <span class="helper"></span>

  @if (isVideo(sources[$active()])) {
    <video
      #video
      id="video"
      class="full-width"
      autoplay
      poster="/assets/imgs/default.jpg"
    >
      <!-- <source type="video/webm" [attr.srcset]="environment.apiUrl + sources[active].src + '.webm'" /> -->
      <source
        type="video/mp4"
        [attr.src]="environment.apiUrl + sources[$active()].src + '.mp4'"
      />
      <p>
        Votre navigateur ne prend pas en charge les vidéos HTML5. Voici
        <a [attr.href]="environment.apiUrl + sources[$active()].src + '.mp4'"
          >un lien pour télécharger la vidéo</a
        >.
      </p>
    </video>
  }

  @if (isImage(sources[$active()])) {
    <picture #picture id="picture" class="full-width" controls itemprop="image">
      <source
        type="image/webp"
        [srcset]="environment.apiUrl + sources[$active()].src + '.webp'"
      />
      <source
        type="image/jpeg"
        [srcset]="environment.apiUrl + sources[$active()].src + '.jpg'"
      />
      <source
        type="image/png"
        [srcset]="environment.apiUrl + sources[$active()].src + '.png'"
      />
      <img loading="lazy" />
    </picture>
  }

  <div
    tabindex="0"
    role="button"
    [class]="['fullscreen', isVideo(sources[$active()]) ? 'inverse' : '']"
    (click)="toggleFullscreen($event)"
  >
    <fa-icon
      class="minimize"
      [icon]="['fas', 'minimize']"
      title="{{ 'Réduire' }}"
    ></fa-icon>

    <fa-icon
      class="maximize"
      [icon]="['fas', 'maximize']"
      title="{{ 'Mettre en plein écran' }}"
    ></fa-icon>
  </div>

  @if (sources?.length > 1) {
    <div
      tabindex="0"
      role="button"
      [class]="['next', isVideo(sources[$active()]) && 'inverse']"
      (click)="next($event); $event.stopPropagation()"
    >
      <fa-icon
        [icon]="['fas', 'chevron-right']"
        title="{{ 'Suivant' }}"
      ></fa-icon>
    </div>

    <div
      tabindex="0"
      role="button"
      [class]="['prev', isVideo(sources[$active()]) && 'inverse']"
      (click)="prev($event); $event.stopPropagation()"
    >
      <fa-icon
        [icon]="['fas', 'chevron-left']"
        title="{{ 'Précédent' }}"
      ></fa-icon>
    </div>
  }
</div>

@if (sources?.length > 1) {
  <div #thumbnails class="thumbnails">
    @for (source of sources; track source.src) {
      @if (isVideo(source)) {
        <div
          [class]="['thumbnail-video', $active() === $index ? 'active' : '']"
          (click)="select($index)"
        >
          <fa-icon
            [icon]="['fas', 'circle-play']"
            title="{{ 'Lire la vidéo' }}"
          ></fa-icon>
        </div>
      }

      @if (isImage(source)) {
        <picture
          #picture
          id="picture"
          title="Voir l'image"
          [class]="['thumbnail-image', $active() === $index ? 'active' : '']"
          controls
          itemprop="image"
          (click)="select($index)"
        >
          <source
            type="image/webp"
            [srcset]="environment.apiUrl + source.src + '.webp'"
          />
          <source
            type="image/jpeg"
            [srcset]="environment.apiUrl + source.src + '.jpg'"
          />
          <source
            type="image/png"
            [srcset]="environment.apiUrl + source.src + '.png'"
          />
          <img loading="lazy" [alt]="source.src" />
        </picture>
      }
    }
  </div>
}
